import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VideoModalComponent } from '../../../../shared/modals/video-modal/video-modal.component';
import { arrayUnion, doc, setDoc, updateDoc } from 'firebase/firestore';
import { Firestore, collectionData } from '@angular/fire/firestore';
import { MiniClipsService } from '../../components/podcasts/miniClips.service';
import { Renderer2 } from '@angular/core';
import { LogoutService } from '../../../auth/components/auth/auth.service';
​
@Component({
  selector: 'app-miniclips-modal',
  templateUrl: './miniclips-modal.component.html',
  styleUrls: ['./miniclips-modal.component.scss']
})
export class MiniclipsModalComponent implements OnInit {
  roundOne: any;
  roundTwo: any;
  roundThree: any;
  selectedVideoUrl: any;
  showVideoModal: any = false;
  clips: any = [];
  totalDurationInRound: number = 0;
  watchedVideosInRoundOne: Set<string> = new Set<string>();
  roundIndex: any;
  selectedRound: any;
  activeIndex: number = 0;
  globalClips:any;
  blockLoader = "blockLoader";
​
  constructor(private snackbar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<MiniclipsModalComponent>,
    private el: ElementRef, public dialog: MatDialog,
    private firestore: Firestore,
    private miniClipsService: MiniClipsService,
    private renderer: Renderer2,
    private logoutService: LogoutService) { }
​
  async ngOnInit() {
	await this.spinner.show("blockLoader");
    await this.getUserMiniClipsByEmail();
	await this.spinner.hide("blockLoader");
	this.selectedRound = this.clips[this.activeIndex].name;
  }
​
  closeModal() {
    this.dialogRef.close()
  }
​
  async openVideoModal(clipsData: any, videoClipIndex: any) {
    clipsData[this.activeIndex].totalDurationClips = this.totalDurationInRound;
    if(clipsData[this.activeIndex].status === 'Not Started') {
      clipsData[this.activeIndex].status = 'In Progress'
    }
    // console.log('data', clipsData);
    const dialogRef = this.dialog.open(VideoModalComponent, {
      width: '70vw',
      height: '80vh',
      panelClass: 'video-modal',
      data : {
        clipsData: clipsData,
        clipsIndex: this.activeIndex,
        videoClipIndex: videoClipIndex
      }
    });
​
    dialogRef.afterClosed().subscribe(async (result: any) => {
    	this.totalDurationInRound = 0;
		await this.spinner.show("blockLoader");
    	await this.getUserMiniClipsByEmail();
		await this.spinner.hide("blockLoader");
    });
  }
​
  closeVideoModal() {
    this.selectedVideoUrl = '';
    this.showVideoModal = false;
  }

  async getUserMiniClipsByEmail(){
    let userEmail = localStorage.getItem('username');
    const userData = await this.logoutService.getUserByEmail(userEmail);
    let globalMiniClips = await this.getMiniClips();
    this.clips = globalMiniClips;
    if(userData && userData[0].miniClipsData) {
      let userMiniClips = userData[0].miniClipsData;
      console.log('userMiniClips', userMiniClips);

      for(let i = 0; i < userMiniClips.length; i++) {
        let existingIndex = this.clips.findIndex((el:any) => el.id === userMiniClips[i].id);
        if(existingIndex !== -1){
          this.clips[existingIndex].status = userMiniClips[i].status;
          this.clips[existingIndex].miniClipVideosProgress = userMiniClips[i].miniClipVideosProgress;
          for(let j = 0; j < userMiniClips[i].miniClipData.length; j++){
            this.clips[existingIndex].miniClipData[j].completed = userMiniClips[i].miniClipData[j].completed;
            this.clips[existingIndex].miniClipData[j].progressTime = userMiniClips[i].miniClipData[j].progressTime;
          }
        }
      }
    }
  }

  async getMiniClips(){
    return await this.miniClipsService.getMiniClips();
  }
​
getStatus(clipIndex: any){
  let progress = (this.clips[clipIndex].miniClipVideosProgress * 100) / this.clips[clipIndex].totalDurationClips;
  // console.log('progress', progress);
  let nan = isNaN(progress);
//   console.log('progress', progress);
  if(nan) return 'Not Started';
  else if(Math.floor(progress) == 0) return 'Not Started';
  else if(Math.floor(progress) > 0 && Math.floor(progress) !== 100) return 'In Progress';
  else if(Math.floor(progress) === 100 ) return 'Completed';
}
​
  onVideoMetadataLoaded(event: Event, item: any) {
    let clipDuration = 0;
    const videoElement = event.target as HTMLVideoElement;
    if (!isNaN(videoElement.duration)) {
      clipDuration = Math.floor(videoElement.duration);
      // console.log('item', item)
      if(item.totalTime === 0) {
        item.totalTime = clipDuration
      }
      this.totalDurationInRound += clipDuration;
    //   console.log('this.totalDuration', this.totalDurationInRound, 'clipDuration', clipDuration);

    }

    // console.log('this.totalDurationInRound', this.totalDurationInRound);
    setTimeout(() => {
      this.clips[this.activeIndex].totalDurationClips = this.totalDurationInRound;
    }, 5000)
    // console.log('this.clips[this.activeIndex]', this.clips[this.activeIndex]);
  }

  selecteRound(roundName: any, index: any) {
    this.totalDurationInRound = 0;
    this.activeIndex = index;
    this.selectedRound = roundName;
  }

  getProgressPercentage(item: any) {
	// console.log()
	// console.log(item.miniClipVideosProgress);
	// console.log(item.totalDurationClips);
	if (item.miniClipVideosProgress >= 1 && item.totalDurationClips === 0) {
		return "Loading...";
	}
    let percentage = (item.miniClipVideosProgress * 100) / item.totalDurationClips;
    let progress = isNaN(percentage);
	if (percentage >= 100) {
		percentage = 100;
	}
	if (percentage === Infinity) {
		return "Loading...";
	}
    if (progress) {
		return 0;
	} else if(!progress) {
		return Math.floor(percentage);
	}
  }

  getBackgroundColor(status: string){
    if(status === 'Not Started') return 'black';
    else if(status === 'In Progress') return '#8BEFD1';
    else if(status === 'Completed') return '#7881e6';
  }


//   addMiniClips(){
//     let data = {
//       active: true,
//       miniClipVideosProgress: 0,
//       name: 'Round 1',
//       totalDurationClips: 0,
//       status: 'Not started',
//       miniClipData: [
//         {
//           completed: false,
//           progressTime: 0,
//           totalTime: 0,
//           imageUrl: 'https://wallpapers.com/images/hd/abstract-background-6m6cjbifu3zpfv84.jpg',
//           videoUrl: 'https://firebasestorage.googleapis.com/v0/b/bwi-1130.appspot.com/o/miniclips%2FvideoSample.mp4?alt=media&token=35294c31-3aa8-41ce-a44b-a7619540b4de'
//         }, {
//           completed: false,
//           progressTime: 0,
//           totalTime: 0,
//           imageUrl: 'https://wallpapers.com/images/hd/abstract-background-6m6cjbifu3zpfv84.jpg',
//           videoUrl: 'https://firebasestorage.googleapis.com/v0/b/bwi-1130.appspot.com/o/miniclips%2FvideoSample.mp4?alt=media&token=35294c31-3aa8-41ce-a44b-a7619540b4de'
//         },
//         {
//           completed: false,
//           progressTime: 0,
//           totalTime: 0,
//           imageUrl: 'https://wallpapers.com/images/hd/abstract-background-6m6cjbifu3zpfv84.jpg',
//           videoUrl: 'https://firebasestorage.googleapis.com/v0/b/bwi-1130.appspot.com/o/miniclips%2FvideoSample.mp4?alt=media&token=35294c31-3aa8-41ce-a44b-a7619540b4de'
//         },
//         {
//           completed: false,
//           progressTime: 0,
//           totalTime: 0,
//           imageUrl: 'https://wallpapers.com/images/hd/abstract-background-6m6cjbifu3zpfv84.jpg',
//           videoUrl: 'https://firebasestorage.googleapis.com/v0/b/bwi-1130.appspot.com/o/miniclips%2FvideoSample.mp4?alt=media&token=35294c31-3aa8-41ce-a44b-a7619540b4de'
//         }
//       ]
//     }
// ​
//     this.miniClipsService.addMiniClips(data);
//   }
}